import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from 'antd-v5';

/**
 * EventKPICards component displays key performance indicators for an event
 */
const EventKPICards = ({
  event,
  totalAudience,
  recentContactPercentage,
  recentContactCount,
  salesAmount,
  isLoadingSales,
}) => {
  const audienceCount = totalAudience || event.audienceCount || 0;
  const contactedCount = recentContactCount ?? event.contactedCount ?? 0;
  const appointmentsCount = event.clientsWithAppointmentsCount || 0;
  const salesValue = salesAmount ?? 0;

  // Use recentContactPercentage from audience API if available, otherwise calculate
  const getContactedPercent = () => {
    if (recentContactPercentage != null) {
      return Math.round(recentContactPercentage);
    }
    if (audienceCount > 0) {
      return Math.round((contactedCount / audienceCount) * 100);
    }
    return 0;
  };
  const contactedPercent = getContactedPercent();

  const appointmentsPercent = audienceCount > 0 ? Math.round((appointmentsCount / audienceCount) * 100) : 0;

  // Format currency
  const formatCurrency = amount => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <div className="event-kpi-cards">
      <div className="kpi-card">
        <div className="kpi-label">Audience</div>
        <div className="kpi-value">{audienceCount.toLocaleString()}</div>
      </div>

      <div className="kpi-card">
        <div className="kpi-label">Contacted last 7 days</div>
        <div className="kpi-value">
          {contactedCount.toLocaleString()}
          <span className="kpi-suffix">{contactedPercent}%</span>
        </div>
      </div>

      <div className="kpi-card">
        <div className="kpi-label">Appointments</div>
        <div className="kpi-value">
          {appointmentsCount.toLocaleString()}
          <span className="kpi-suffix">{appointmentsPercent}%</span>
        </div>
      </div>

      <div className="kpi-card">
        <div className="kpi-label">Sales from appointments</div>
        <div className="kpi-value">
          {isLoadingSales ? (
            <Skeleton.Input active size="small" className="kpi-skeleton" />
          ) : (
            formatCurrency(salesValue)
          )}
        </div>
      </div>
    </div>
  );
};

EventKPICards.propTypes = {
  event: PropTypes.shape({
    audienceCount: PropTypes.number,
    contactedCount: PropTypes.number,
    clientsWithAppointmentsCount: PropTypes.number,
  }),
  totalAudience: PropTypes.number,
  recentContactPercentage: PropTypes.number,
  recentContactCount: PropTypes.number,
  salesAmount: PropTypes.number,
  isLoadingSales: PropTypes.bool,
};

EventKPICards.defaultProps = {
  event: {},
  totalAudience: 0,
  recentContactPercentage: null,
  recentContactCount: null,
  salesAmount: null,
  isLoadingSales: false,
};

export default EventKPICards;
